/**
 * `futurex init` / `futurex compact` — bootstrap and bound the project memory file.
 */
import { buildRepoCard, findRepoRoot, MEMORY_FILENAME } from './repo.js';
import { loadRetriever } from './index-store.js';
import { bootstrapMemory, compactMemory, MEMORY_TOKEN_LIMIT } from './memory.js';
import { info } from './ui.js';

/** `futurex init` — write a provisional futurex-memory.md if one is absent. */
export function runInit(): void {
  const root = findRepoRoot();
  const card = buildRepoCard(root);
  const symbols = loadRetriever(root)?.symbols ?? null;
  if (bootstrapMemory(root, card, symbols)) {
    info(`created ${MEMORY_FILENAME} at ${root} — edit it to guide FutureX`);
  } else {
    info(`${MEMORY_FILENAME} already exists — leaving it untouched`);
  }
}

/** `futurex compact` — bound memory growth (regenerate derived sections + archive decisions). */
export function runCompact(): void {
  const root = findRepoRoot();
  const card = buildRepoCard(root);
  const symbols = loadRetriever(root)?.symbols ?? null;
  const res = compactMemory(root, card, symbols);
  switch (res.action) {
    case 'absent':
      info(`no ${MEMORY_FILENAME} — run \`futurex init\` first`);
      return;
    case 'unchanged':
      info(`${MEMORY_FILENAME} is ~${res.beforeTokens} tok (≤ ${MEMORY_TOKEN_LIMIT}) — no compaction needed`);
      return;
    case 'compacted':
      info(
        `compacted ${MEMORY_FILENAME}: ~${res.beforeTokens} → ~${res.afterTokens} tok` +
          (res.archived ? ` · decisions archived to ${res.archived}` : ''),
      );
      return;
  }
}
